<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KHdkBw/tc-custom/9781429967365.jpg?1737775547048" alt="This image is the cover for the book Conspiracies, Repairman Jack"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Conspiracies, Repairman Jack
      </h1>
      <p class="bookDescription body article font2">
        <p>Repairman Jack, F. Paul Wilson's vigilante hero from the <i>New York Times </i>bestseller <i>The Tomb</i>, returns in a thriller that thrusts him back into the weird, supernatural world that he thrives in.<br/><br/>Looking for clues to the mysterious disappearance of leading conspiracy theorist Melanie Ehler, Jack attends a convention of bizarre and avid conspiracy theorists. It's a place where aliens are real, the government is out to get you, and the world is hurtling toward an inevitable war of good versus evil incarnate.<br/><br/>Jack finds that nobody can be trusted--and that few people are what they seem. Worse yet, Jack's been having vivid dreams that make him wonder whether he's headed for a clash with his own past--maybe <i>The Tomb</i>'s evil rakoshi beasts aren't through with him quite yet.<br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        F. Paul Wilson
      </h2>
      
      <p class="authorDescription body article">F. Paul Wilson is the author of more than fifty books spanning various genres, including science fiction, horror, thriller, and more. Four of his novels have been <I>New York Times</I> bestsellers, and his work has earned him four Prometheus Awards, the prestigious Inkpot Award from the San Diego Comic-Con, and the Pioneer Award from the RT Booklovers Convention.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ce095e94